module.exports = __webpack_public_path__ + "static/create-po-number-custom-field-97da6f86ee4b3e09de029965aca6576b.png";